import noUiSlider from "nouislider";

Window.range = (ctx, minVal, maxVal, currentMin, currentMax, changeEvent) => {
    noUiSlider.create(ctx, {
        start: [currentMin, currentMax],
        step: 100,
        connect: true,
        range: {
            min: minVal,
            max: maxVal,
        },
    });

    ctx.noUiSlider.on("change", changeEvent);
};
